import { Component, OnDestroy, Input, HostBinding, ElementRef, Optional, Self } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { Subject } from 'rxjs';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as moment from 'moment';

export class RevisedDate{
  constructor(public plannedDate:Date, public isDateRevised:boolean, public revisedDate:Date){

              }

  get dateStr():string{
    //if(this.plannedDate && this.revisedDate){
      if(this.isDateRevised == true && this.plannedDate && this.revisedDate){
        return moment(this.revisedDate).format(MaterialRevisedDateComponent.dateFormat) + " (" + 
               moment(this.plannedDate).format(MaterialRevisedDateComponent.dateFormat) + ") ";
      }
      // else{
      //   return moment(this.plannedDate).format(MaterialRevisedDateComponent.dateFormat);
      // } //Patched applied below for a specific condition where planned is not there but revised is there
      else if(this.plannedDate){
        return moment(this.plannedDate).format(MaterialRevisedDateComponent.dateFormat);
      }
      else if(this.revisedDate){
        return moment(this.revisedDate).format(MaterialRevisedDateComponent.dateFormat);
      }
    //}
    return '';
  }
}
@Component({
  selector: 'material-revised-date',
  templateUrl: './material-revised-date.component.html',
  styleUrls: ['./material-revised-date.component.css'],
  providers:[
    {
      provide:MatFormFieldControl, useExisting: MaterialRevisedDateComponent
    }
  ]

})
export class MaterialRevisedDateComponent implements MatFormFieldControl<RevisedDate>, OnDestroy {
  static dateFormat:string  = 'MMM DD, YYYY';
  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'split-revised-date';
  private _required = false;
  private _placeholder: string;
  private _disabled = false;

  @HostBinding() id = 'split-date-'+(MaterialRevisedDateComponent.nextId++)+'\'';
  @HostBinding('class.floating')
  get shouldLabelFloat(){
    return this.focused || !this.empty;
  }
  @HostBinding('attr.aria-describedby') describedBy = '';

  setDescribedByIds(ids:string[]){
    this.describedBy = ids.join(' ');
  }

  

  @Input() 
  get value():RevisedDate | null{
    let n = this.parts.value;
    return new RevisedDate(n.plannedDate,n.revisedDate,n.revisedDateStr);
  }
  set value(nums:RevisedDate | null){
    //nums = nums || new RevisedDate(null,false,null);
    this.parts.setValue({
                          plannedDate: nums.plannedDate,
                          isRevised: nums.isDateRevised,
                          revisedDate: nums.revisedDate,
                          dateStr: nums.dateStr
                        });
    this.stateChanges.next();
  }

  @Input()
  get placeholder(){
    return this._placeholder;
  }
  set placeholder(plh){
    this._placeholder = plh;
    this.stateChanges.next();
  }
  
  @Input()
  get required(){
    return this._required;
  }
  set required(req){
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  @Input()
  get disabled(){
    return this._disabled;
  }
  set disabled(dis){
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }


  onContainerClick(event:MouseEvent){
    // if((event.target as Element).tagName.toLowerCase() != 'input'){
    //   this.elRef.nativeElement.querySelector('input').focus();
    // }
  }

  get empty(){
    if(this.parts == null || this.parts.value == null || 
      (this.parts.value.plannedDate == null && this.parts.value.revisedDate == null)){
        return true;
      }
    return false;
    // let n = this.parts.value;
    // return !n.firstNum && !n.secondNum;
  }
  
  constructor(fb: UntypedFormBuilder, private fm:FocusMonitor, private elRef:ElementRef<HTMLElement>, 
    @Optional() @Self() public ngControl: NgControl) { 

      this.parts = fb.group({
        'plannedDate':null,
        'isRevised':false,
        'revisedDate':null,
        'dateStr':''
      });

      fm.monitor(elRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }

  ngOnDestroy(){
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }
}
